import { render, staticRenderFns } from "./AgricoltoriSelect.vue?vue&type=template&id=7842c38e&"
import script from "./AgricoltoriSelect.vue?vue&type=script&lang=js&"
export * from "./AgricoltoriSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports